import React__default from 'react';
import { elementQuerySelector } from '@keepeek/commons';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import DefaultIcon from '../../../DefaultIcon/index.js';
import PictureViewer from '../../../Viewer/PictureViewer/index.js';
import PictureViewerAction from '../../../Viewer/PictureViewer/components/PictureViewerAction/index.js';

var ComparatorItem = function ComparatorItem(_a) {
    var elementId = _a.elementId, actions = _a.actions, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b;
    var element = useRecoilValue(elementQuerySelector({ elementId: elementId }));
    var t = useTranslation("refront-components").t;
    if (!element) {
        return React__default.createElement(React__default.Fragment, null);
    }
    var title = (!Array.isArray(element.title.value) && element.title.value) || "";
    return (React__default.createElement(Box, { sx: {
            width: "100%",
            height: "100%",
            textAlign: "center",
            display: "grid",
            gridTemplate: "minmax(0, 100%) 1fr / minmax(0, 100%)"
        }, key: element.id },
        React__default.createElement(PictureViewer, { media: element, mode: "center", enableWheelZoom: true, topLeftHoverComponents: actions === null || actions === void 0 ? void 0 : actions.map(function (action) { return (React__default.createElement(PictureViewerAction, { title: action.title, ariaLabel: action.ariaLabel, icon: React__default.createElement(KIcon, { className: action.fontAwesomeIcon }), onClick: function () { return action.onClick(elementId); } })); }), topRightZoomIn: React__default.createElement(PictureViewerAction, { title: t("components.picture-viewer.action.zoom-in.label"), ariaLabel: t("components.picture-viewer.action.zoom-in.label"), icon: React__default.createElement(KIcon, { className: "fa-search-plus" }) }), topRightZoomOut: React__default.createElement(PictureViewerAction, { title: t("components.picture-viewer.action.zoom-out.label"), ariaLabel: t("components.picture-viewer.action.zoom-out.label"), icon: React__default.createElement(KIcon, { className: "fa-search-minus" }) }) }),
        React__default.createElement(Box, null,
            React__default.createElement(Typography, { variant: "subtitle2", component: Box, title: title, "aria-label": title, noWrap: true }, title))));
};

export { ComparatorItem as default };
//# sourceMappingURL=index.js.map
